'use client'

import Image from 'next/image'
import { useAnimateOnVisible } from '@hooks/useAnimateOnVisible'
import styles from './AckoIdentity.module.scss'

const AckoIdentityLogo = ({ backgroundColor, image }: { backgroundColor: string; image: string }) => {
  const { ref, animationClassName } = useAnimateOnVisible<HTMLDivElement>()
  return (
    <div
      ref={ref}
      className={`${styles.ackoIdentityLogo} ${animationClassName}`}
      style={{
        backgroundColor,
      }}>
      <Image src={image} alt="acko logo" height={48} width={412} />
    </div>
  )
}

export default AckoIdentityLogo
